import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../images/iitrprlogo.png";
import tbiflogo from "../global-images/tbif-iit-ropar.png";
import { FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import "../styles/Navbar.css";
import TeamP from "./TeamPage";
import { useLocation } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownfOpen, setIsDropdownfOpen] = useState(false);
  const [isDropdownfaOpen, setIsDropdownfaOpen] = useState(false);
  const [isDropdownPortOpen, setIsDropdownPortOpen] = useState(false);
  
  const location = useLocation();
  const topRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <nav className="fixed z-50 h-20 lg:px-20 px-10 bg-white w-full flex justify-center items-center border-b border-gray-500" ref={topRef}>
      <div className={`w-full text-black z-20 flex items-center justify-between shadow-sm `}>
        <div className="logo flex items-center justify-center">
          <a href="https://iitrpr.ac.in">
            <img
              src={logo}
              alt="IIT Ropar Logo"
              className="h-16 str logo-img"
            />
          </a>
          <Link
            to="https://www.iitrpr.ac.in/tbif/"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <img
              src={tbiflogo}
              alt="Home"
              className=" h-15 ml-5 bg-blend-lighten hover:bg-blend-darken"
            />
          </Link>
        </div>
        <div className="hidden lg:block font-montserrat font-bold justify-end">
          <ul className=" flex items-center space-x-4 text-sm ">
            <li>
              <Link
                to="/"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="hover:text-blue-600"
              >
                Home
              </Link>
            </li>
            <li
              className="relative"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <li
                className="justify-between rounded-lg  flex items-center hover-underline-animation cursor-pointer hover:text-blue-600"
              >
                <h1 className="p-1">About</h1>
                <FaChevronDown
                  className={`chevron-icon ${isDropdownOpen ? "rotate" : ""} `}
                />
              </li>
              {isDropdownOpen && (
                <ul className="dropdown p-2 rounded  shadow-md z-30">
                  <li>
                    <Link
                      to="/about"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="px-2 py-1 rounded  whitespace-nowrap hover:text-blue-500 text-white"
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/team"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="px-2 py-1 rounded  whitespace-nowrap hover:text-blue-500 text-white"
                    >
                      Dedicated Team
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li
              onMouseEnter={() => setIsDropdownfOpen(true)}
              onMouseLeave={() => setIsDropdownfOpen(false)}
            >
              <li
                className="justify-between rounded-lg  flex items-center hover-underline-animation cursor-pointer hover:text-blue-600"
              >
                <h1 className="p-1">Support</h1>
                <FaChevronDown
                  className={`chevron-icon ${isDropdownfOpen ? "rotate" : ""}`}
                />
              </li>
              {isDropdownfOpen && (
                <ul className="dropdown p-2 rounded shadow-md z-30">
                  <li>
                    <Link
                      to="/facilities"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="px-2 py-1 rounded whitespace-nowrap hover:text-blue-500 text-white "
                    >
                      Incubator Facilities
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mentors"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="px-2 py-1 rounded whitespace-nowrap hover:text-blue-500 text-white "
                    >
                      Mentors & SME's
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/defence"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="px-2 py-1 rounded whitespace-nowrap hover:text-blue-500 text-white "
                    >
                      Defence Based StartUps
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li
              className="relative"
              onMouseEnter={() => setIsDropdownPortOpen(true)}
              onMouseLeave={() => setIsDropdownPortOpen(false)}
            >
              <li
                className="justify-between rounded-lg  flex items-center cursor-pointer hover:text-blue-600"
              >
                <h1 className="p-1">Portfolio</h1>
                <FaChevronDown
                  className={`chevron-icon ${
                    isDropdownPortOpen ? "rotate" : ""
                  } `}
                />
              </li>
              {isDropdownPortOpen && (
                <ul className="dropdown p-2 rounded shadow-md z-30">
                  <li>
                    <Link
                      to="/portfolio"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="px-2 py-1 rounded  whitespace-nowrap hover:text-blue-500 text-white"
                    >
                      Incubatees Startups
                    </Link>
                  </li>
                  <li>
                    <Link to="/mous" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="px-2 py-1 rounded text-white hover:text-blue-500 hover-underline-animation">MoUs Signed
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link
                to="/events"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="hover:text-blue-600 p-2"
              >
                Events
              </Link>
            </li>
            <li>
              <Link
                to="/career"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="hover:text-blue-600 p-2"
              >
                Careers
              </Link>
            </li>
            <li>
              <Link
                to="/SchoolOfEntrepreneurship"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="hover:text-blue-600 p-2"
              >
                School Of Entrepreneurship
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="hover:text-blue-600 p-2"
              >
                Contact Us
              </Link>
            </li>
            <li>
              <Link
                target="_blank"
                to="https://forms.gle/RyUWnEhZGNerNkhc8"
                className=" bg-blue-600 text-white rounded-xl px-3 py-2"
              >
                Incubate!
              </Link>
            </li>
          </ul>
        </div>
        <div className="lg:hidden flex items-center justify-end">
          <button
            className={`ham_col hamburger ${isOpen ? "open" : ""}`}
            onClick={toggleMenu}
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </button>
        </div>
        {isOpen && (
          <div className="dropdown-menu fixed inset-0 bg-black flex flex-col  justify-start ">
            <button className="absolute top-5 right-5" onClick={toggleMenu}>
            </button>
            <ul className="text-white text-2xl text-center">
              <li className="">
                <Link
                  className="hover:text-blue-400"
                  to="/"
                  onClick={() => {
                    toggleMenu();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Home
                </Link>
              </li>
              <li
                className="relative flex justify-center items-center "
                onMouseEnter={() => setIsDropdownfOpen(true)}
                onMouseLeave={() => setIsDropdownfOpen(false)}
              >
                <button
                  className="justify-center rounded-lg p-2 flex items-center hover-underline-animation hover:text-blue-400"
                >
                  About
                  <FaChevronDown
                    className={`chevron-icon ${
                      isDropdownfOpen ? "rotate" : ""
                    }`}
                  />
                </button>
                {isDropdownfOpen && (
                  <ul className=" dropdown mt-2 p-2 rounded shadow-md z-30">
                    <li>
                      <Link
                        to="/about"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfOpen(false);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="px-2 py-1 hover:text-blue-400 rounded whitespace-nowrap "
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/team"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfOpen(true);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="px-2 py-1 hover:text-blue-400 rounded whitespace-nowrap "
                      >
                        Dedicated Team
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li
                className="relative flex justify-center items-center "
                onMouseEnter={() => setIsDropdownfaOpen(true)}
                onMouseLeave={() => setIsDropdownfaOpen(false)}
              >
                <button
                  className="justify-center rounded-lg p-2 flex items-center hover-underline-animation hover:text-blue-400"
                >
                  Support
                  <FaChevronDown
                    className={`chevron-icon ${
                      isDropdownfaOpen ? "rotate" : ""
                    }`}
                  />
                </button>
                {isDropdownfaOpen && (
                  <ul className="dropdown mt-2 p-2 rounded shadow-md z-30">
                    <li>
                      <Link
                        to="/facilities"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfaOpen(false);
                          topRef.current.scrollIntoView({ behavior: "smooth" });
                        }}
                        className="px-2 py-1 hover:text-blue-400 rounded whitespace-nowrap "
                      >
                        Existing Facilities
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/mentors"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfaOpen(false);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="px-2 py-1 hover:text-blue-400 rounded whitespace-nowrap "
                      >
                        Mentors & SME's
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/defence"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfaOpen(false);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="px-2 hover:text-blue-400 py-1 rounded whitespace-nowrap "
                      >
                        Defence Based Startups
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li
                className="relative flex justify-center items-center "
                onMouseEnter={() => setIsDropdownPortOpen(true)}
                onMouseLeave={() => setIsDropdownPortOpen(false)}
              >
                <button
                  className="justify-center rounded-lg p-2 flex items-center hover-underline-animation hover:text-blue-400"
                >
                  Portfolio
                  <FaChevronDown
                    className={`chevron-icon ${
                      isDropdownPortOpen ? "rotate" : ""
                    }`}
                  />
                </button>
                {isDropdownPortOpen && (
                  <ul className=" dropdown mt-2 p-2 rounded shadow-md z-30">
                    <li>
                      <Link
                        to="/portfolio"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfOpen(false);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="px-2 hover:text-blue-400 py-1 rounded whitespace-nowrap "
                      >
                        Incubatees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/mous"
                        onClick={() => {
                          toggleMenu();
                          setIsDropdownfOpen(false);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="px-2 hover:text-blue-400 py-1 rounded whitespace-nowrap "
                      >
                        MoUs Signed
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link
                  className="hover:text-blue-400"
                  to="/events"
                  onClick={() => {
                    toggleMenu();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Events
                </Link>
              </li>
              <li>
                <Link
                  className="hover:text-blue-400"
                  to="/career"
                  onClick={() => {
                    toggleMenu();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/SchoolOfEntrepreneurship"
                  onClick={() => {
                    toggleMenu();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="hover:text-blue-400"
                >
                  School Of Entrepreneurship
                </Link>
              </li>
              <li>
                <Link
                  className="hover:text-blue-400"
                  to="/contact-us"
                  onClick={() => {
                    toggleMenu();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  className=" bg-blue-500 hover:scale-105 p-3 rounded-lg font-bold"
                  target="_blank"
                  to="https://forms.gle/RyUWnEhZGNerNkhc8"
                  onClick={toggleMenu}
                >
                  Incubate!
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;